module.exports = __webpack_public_path__ + "img/Slice152.36f0c370.png";